module.exports = __webpack_public_path__ + "static/media/rocket.03615288.png";